<div class="menu-buttons">
  @for (button of buttons; track $index) {
    <div class="menu-button-container">
      <button
        type="button"
        class="menu-button"
        [class.menu-button-active]="button.isActive"
        [class.menu-button-disabled]="disabled()"
        (click)="setActiveMode(button)"
        matRipple>
        <mat-icon [svgIcon]="button.icon"></mat-icon>
        <span class="noselect">{{ button.titleKey | translate }}</span>
      </button>
    </div>
  }
</div>
